<template>
    <div class="container-fluid d-flex flex-column">
        <div class="row justify-content-center min-vh-100">
            <div class="col-md-6 col-lg-5 col-xl-4 py-6 py-md-0 mt-5">
                <div class="card" style="max-width: 600px; margin: 0 auto;">
                    <div class="d-flex justify-content-end mr-2 mt-1">
                        <LanguageSwitcher />
                    </div>

                    <div class="card-body">
                        <div class="card-header"></div>

                        <div>
                            <div class="mb-5 text-center">
                                <CompanyImage :type="CompanyImageType.Logo" max-height="140px" max-width="100%" />
                            </div>

                            <div class="alert alert-danger mb-5" v-if="errormessage">
                                {{ $t('code.error_message') }}
                            </div>

                            <strong class="d-block text-center">
                                {{ $t('code.enter_code_prompt') }}
                            </strong>

                            <span class="clearfix"></span>
                            <form>
                                <div class="form-group">
                                    <label class="form-control-label">
                                        {{ $t('code.code_label') }}
                                    </label>
                                    <input type="text" v-model="request.code" :disabled="loading" class="form-control"
                                           id="input-code" placeholder=""
                                           @keydown.enter="checkCode">
                                </div>

                                <div class="mt-4">
                                    <button type="button" @click="checkCode" :disabled="loading"
                                            class="btn btn-block btn-primary">
                                        {{ $t('code.view_button') }}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import LanguageSwitcher from '../../components/LanguageSwitcher.vue';
    import * as Sentry from '@sentry/vue';
    import { CompanyImageType } from '../../enums/company-image-type';
    import CompanyImage from '../../components/CompanyImage.vue';

    export default {
        components: {
            CompanyImage,
            LanguageSwitcher,
        },

        data() {
            return {
                loading: false,
                request: {
                    code: null,
                },
                errormessage: null,
            };
        },

        created() {
            this.errormessage = this.$route.query.message;
        },

        computed: {
            CompanyImageType() {
                return CompanyImageType;
            }
        },

        methods: {
            async checkCode() {
                if (!this.request.code) {
                    return;
                }

                if (Object.keys(this.$route.query).length) {
                    await this.$router.replace({
                        query: null,
                    });
                }

                this.loading = true;

                try {
                    await this.$http.get('/api/ceremonies/code/' + this.request.code);

                    await this.$router.push('/code/' + this.request.code);
                } catch (exception) {
                    Sentry.captureException(exception);
                    this.errormessage = this.$t('code.invalid_code_message');
                    this.loading = false;
                }
            },
        },
    };

</script>
